import { DescriptionResponseBuilder } from 'gql/autogen/DescriptionResponseBuilder';
import { SectionResponseBuilder } from 'gql/autogen/SectionResponseBuilder';
import { BenefitItemResponseBuilder } from 'gql/autogen/BenefitItemResponseBuilder';
import { BenefitItemsReferenceResponseBuilder } from 'gql/autogen/BenefitItemsReferenceResponseBuilder';
import { DurationInfoResponseBuilder } from 'gql/autogen/DurationInfoResponseBuilder';
import { LocationRefResponseBuilder } from 'gql/autogen/LocationRefResponseBuilder';
import { SearchErrorResponseBuilder } from 'gql/autogen/SearchErrorResponseBuilder';
import { MediaResponseBuilder } from 'gql/autogen/MediaResponseBuilder';

export const buildDescriptionResponse = () => {
    return new DescriptionResponseBuilder().withSection(new SectionResponseBuilder().withTitle().withDescriptions());
};

export const buildBenefitItemResponse = () => {
    return new BenefitItemResponseBuilder().withName().withDescription();
};

export const buildBenefitItemsReferenceResponse = () => {
    return new BenefitItemsReferenceResponseBuilder().withId().withBenefitItems(buildBenefitItemResponse());
};

export const buildDurationInfoResponse = () => {
    return new DurationInfoResponseBuilder().withMinutes().withDurationType().withMinutesUntil();
};

export const buildLocationRefResponse = () => {
    return new LocationRefResponseBuilder().withDescription().withLocationRefId();
};

export const buildSearchErrorResponse = () => {
    return new SearchErrorResponseBuilder().withErrorCode().withSubErrorCode().withMessage();
};

export const buildMediaResponse = () => {
    return new MediaResponseBuilder().withMediaType().withSource().withDescription();
};
